export function getQueryTerm(query: string, term: string) {
  for (let word of query.split(' ')) {
    if (word.startsWith(term + ':')) {
      return word.substring(term.length + 1);
    }
  }
  return undefined;
}

export function changeQueryTerm(query: string, term: string, value: string | undefined) {
  let newQuery = query.replace(new RegExp(term + ':[^ ]+'), '').trim();
  if (value !== undefined) {
    newQuery = newQuery + ' ' + term + ':' + value;
    newQuery = newQuery.trim();
  }
  return newQuery;
}

export function stripQueryTerms(query: string | undefined, stripTerms: string[]) {
  let filters: any = {};
  for (let term of stripTerms) {
    filters[term] = true;
  }
  query = query !== undefined ? query : '';
  return query
    .split(' ')
    .filter(word => !word.includes(':') || !filters[word.split(':')[0]])
    .join(' ');
}

export function getFilterTerms(query: string, filterTerms: string[]) {
  let filters: any = {};
  for (let term of filterTerms) {
    filters[term] = true;
  }
  return query
    .split(' ')
    .filter(word => word.includes(':') && filters[word.split(':')[0]])
    .join(' ');
}



// WEBPACK FOOTER //
// ./src/common/utils/search.ts